import { render } from "./PhotosListControlsComponent.vue?vue&type=template&id=21fb0b96&ts=true"
import script from "./PhotosListControlsComponent.vue?vue&type=script&lang=ts"
export * from "./PhotosListControlsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__